// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';

import './App.css';

import Login from './pages/Login';
import CreateOrder from './pages/CreateOrder';
import MyOrders from './pages/MyOrders';
import PublicTracking from './pages/PublicTracking';
import Statistics from './pages/Statistics';
import DriversManagement from './pages/DriversManagement';
import VehiclesManagement from './pages/VehiclesManagement';

// Componente para rutas protegidas
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>Cargando...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && userProfile && !allowedRoles.includes(userProfile.rol)) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: 'red' }} className="app-content-container">
        <h3>Acceso Denegado</h3>
        <p>No tienes los permisos necesarios para acceder a esta página.</p>
        <Link to="/">Volver al inicio</Link>
      </div>
    );
  }

  return children;
};

// Componente de la barra de navegación (Navbar)
const Navbar = () => {
  const { currentUser, userProfile, loading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('Sesión cerrada exitosamente.');
      navigate('/login');
    } catch (err) {
      console.error("Error al cerrar sesión:", err.message);
      console.error(`Error al cerrar sesión: ${err.message}`);
    }
  };

  useEffect(() => {
    console.log("Navbar - currentUser:", currentUser);
    console.log("Navbar - userProfile:", userProfile);
    console.log("Navbar - loading auth:", loading);
  }, [currentUser, userProfile, loading]);


  return (
    <nav className="navbar">
      <div>
        <Link to="/" style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
          Implementos y Reactivos - APP Tracking
        </Link>
      </div>
      <div>
        {currentUser ? (
          <>
            {userProfile?.rol === 'Administrador' && (
              <>
                <Link to="/create-order">Crear Pedido</Link>
                <Link to="/my-orders">Mis Pedidos</Link>
                <Link to="/drivers">Conductores</Link>
                <Link to="/vehicles">Vehículos</Link>
                <Link to="/statistics">Estadísticas</Link>
              </>
            )}
            {userProfile?.rol === 'Gerencia' && (
              <>
                <Link to="/my-orders">Mis Pedidos</Link>
                <Link to="/statistics">Estadísticas</Link>
              </>
            )}
            {(userProfile?.rol === 'Asesor' || userProfile?.rol === 'Atención al Cliente') && (
              <>
                <Link to="/create-order">Crear Pedido</Link>
                <Link to="/my-orders">Mis Pedidos</Link>
              </>
            )}
            {userProfile?.rol === 'Almacen' && (
              <>
                <Link to="/my-orders">Mis Pedidos</Link>
              </>
            )}
            
            {loading ? (
              <span style={{ marginRight: '10px', color: 'white' }}>Cargando usuario...</span>
            ) : (
              <span style={{ marginRight: '10px' }}>
                Bienvenido, <strong style={{ color: 'var(--light-blue)' }}>{currentUser.email}</strong> ({userProfile?.rol || 'Rol no definido'})
                <button onClick={handleLogout} className="logout-btn">
                  Cerrar Sesión
                </button>
              </span>
            )}
          </>
        ) : (
          <Link to="/login">Iniciar Sesión</Link>
        )}
      </div>
    </nav>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<PublicTracking />} />
          <Route path="/login" element={<Login />} />

          <Route
            path="/create-order"
            element={
              <ProtectedRoute allowedRoles={['Administrador', 'Asesor', 'Atención al Cliente']}>
                <CreateOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-orders"
            element={
              <ProtectedRoute allowedRoles={['Administrador', 'Gerencia', 'Asesor', 'Almacen', 'Atención al Cliente']}>
                <MyOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics"
            element={
              <ProtectedRoute allowedRoles={['Administrador', 'Gerencia']}>
                <Statistics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/drivers"
            element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <DriversManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <ProtectedRoute allowedRoles={['Administrador']}>
                <VehiclesManagement />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<h2 style={{ textAlign: 'center', padding: '50px' }}>404 - Página no encontrada</h2>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;